/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendPortfolioContactInput = {|
  portfolioOwnerId: string,
  subject: string,
  senderName: string,
  senderEmail: string,
  domainName: string,
  message: string,
|};
export type SendPortfolioMessageMutationVariables = {|
  input: SendPortfolioContactInput
|};
export type SendPortfolioMessageMutationResponse = {|
  +sendPortfolioContact: {|
    +receiverId: string
  |}
|};
export type SendPortfolioMessageMutation = {|
  variables: SendPortfolioMessageMutationVariables,
  response: SendPortfolioMessageMutationResponse,
|};
*/


/*
mutation SendPortfolioMessageMutation(
  $input: SendPortfolioContactInput!
) {
  sendPortfolioContact(input: $input) {
    receiverId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendPortfolioContactPayload",
    "kind": "LinkedField",
    "name": "sendPortfolioContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "receiverId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendPortfolioMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendPortfolioMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f187e0ab6a950bc47d89aa94aead9584",
    "id": null,
    "metadata": {},
    "name": "SendPortfolioMessageMutation",
    "operationKind": "mutation",
    "text": "mutation SendPortfolioMessageMutation(\n  $input: SendPortfolioContactInput!\n) {\n  sendPortfolioContact(input: $input) {\n    receiverId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '858a2d98a42d0ad0d90099b4c2271599';

module.exports = node;
